import React from 'react';
import { Card, Thumbnail, token } from '@bynder/design-system';
import { IconImage, IconVideo } from '@bynder/icons';
import { PartialComponent } from 'packages/services/ComponentService';
import ComponentMenu from './ComponentMenu';
import ComponentThumbnail from './ComponentThumbnail';
import { DisabledCardWrapper, StyledCard } from './styled';

interface Props {
    component: PartialComponent;
    collectionName: string;
    onClick: (isUniqueContentProperties: boolean) => void;
    onEdit: (component: PartialComponent) => void;
    onDelete: (component: PartialComponent) => void;
    isDisabled?: boolean;
}

const ComponentCard = ({ component, collectionName, onClick, onEdit, onDelete, isDisabled = false }: Props) => {
    const handleClick = () => {
        if (!isDisabled) {
            onClick(false);
        }
    };

    const cardContent = (
        <StyledCard
            variant="clean"
            onClick={handleClick}
            contextAction={
                <ComponentMenu
                    component={component}
                    collectionName={collectionName}
                    onApply={onClick}
                    onEdit={() => onEdit(component)}
                    onDelete={() => onDelete(component)}
                    isDisabled={isDisabled}
                />
            }
            noMinWidth
        >
            <Card.Frame
                badge={
                    component.type === 'IMAGE' ? (
                        <Thumbnail
                            variant="clean"
                            icon={<IconImage size="18" />}
                            iconColor={token.white}
                            backgroundColor={token.gray400a}
                            size="xs"
                        />
                    ) : (
                        <Thumbnail
                            variant="clean"
                            icon={<IconVideo size="18" />}
                            iconColor={token.white}
                            backgroundColor={token.gray400a}
                            size="xs"
                        />
                    )
                }
            >
                <ComponentThumbnail component={component} />
            </Card.Frame>
        </StyledCard>
    );

    if (isDisabled) {
        return <DisabledCardWrapper>{cardContent}</DisabledCardWrapper>;
    }

    return cardContent;
};

export default ComponentCard;
